const DIACRITICS = /[̀-ͯ]/g;

// Letters that NFD leaves intact but Postgres `unaccent` rewrites.
const UNACCENT_LETTERS: Record<string, string> = {
  œ: 'oe',
  æ: 'ae',
  ß: 'ss',
  ø: 'o',
  ł: 'l',
  đ: 'd',
  ﬁ: 'fi',
  ﬂ: 'fl',
};
const UNACCENT_PATTERN = new RegExp(`[${Object.keys(UNACCENT_LETTERS).join('')}]`, 'g');

// LIKE / PostgREST wildcards (`%`, `_`, `*`) and the escape character.
const RESERVED_CHARACTERS = /[%_*\\]/g;

// Splits a search into words normalized like the `search_text` columns
// (lowercase, no accents, see `normalize_search_text` in the migrations). Chain
// one `.ilike('search_text', `%${word}%`)` per word so every word must match.
export function toSearchWords(search: string): string[] {
  return search
    .normalize('NFD')
    .replace(DIACRITICS, '')
    .toLocaleLowerCase('fr-FR')
    .replace(UNACCENT_PATTERN, (letter) => UNACCENT_LETTERS[letter])
    .replace(RESERVED_CHARACTERS, ' ')
    .split(/\s+/)
    .filter(Boolean);
}
